export default "__VITE_ASSET__cb4b680a__"